<template>
    <sui-scroll class="igc-tabs"
        horizontal
        :class="{ 'ig--average': average }"
        :style="{ 'background-color': mColor(16) }">
        <div class="ig--tab"
            v-for="(item, index) in tabs"
            :key="item.id"
            :style="{ 'width': average ? `calc(100% / ${ tabs.length })` : '', 'font-weight': active == item.id ? 500 : 400, 'color': active == item.id ? mColor(14) : mColor(15), 'order': item.hasOwnProperty('sort') ? item.sort : index }"
            @click="switchTab(item)">
            <div>{{ item.name }}</div>
            <div class="ig--active"
                v-show="active == item.id"
                :style="{ 'background': mColor(14) }"></div>
        </div>
    </sui-scroll>
</template>

<script>
import mCore from 'scripts/mixins/core'

export default {
    name: 'igc-tabs',

    mixins: [mCore],

    props: {
        tabs: {
            type: Array,
            required: true
        },

        // 选中的 tab id
        active: {
            type: [Number, String],
            required: true
        },

        // 是否平均分布
        average: {
            type: Boolean,
            default: false
        }
    },

    methods: {

        /**
         * 切换导航
         * @param {Object} tab - 所选 tab
         */
        switchTab(tab) {
            this.mEventTracking('tab_1', '选项卡_一级', {
                id: tab.id
            })
            this.$emit('switch-tab', tab)
        }
    }
}
</script>

<style lang="postcss">
.igc-tabs {
    flex: none;
    display: flex;
    height: 70px;
    font-size: 30px;
    .ig--tab {
        flex: none;
        position: relative;
        display: flex;
        align-items: center;
        .ig--active {
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 62px;
            height: 4px;
            border-radius: 2px;
            transform: translate3d(-50%, 0, 0);
        }
    }
}
.igc-tabs.ig--average {
    .ig--tab {
        justify-content: center;
    }
}
.igc-tabs:not(.ig--average) {
    padding: 0 2.4vw;
    .ig--tab {
        padding: 0 2.4vw;
    }
}
.igc-tabs:not(.ig--average)::after {
    flex: none;
    order: 99;
    content: "";
    width: 2.4vw;
}
</style>